import React from "react";
import AddProductoForm from "./AddProductoForm";

const AddProducto = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };

  return (
    <>
      <div className="col-12">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Nuevo Producto"}
        </button>
      </div>

      {show && (
        <div className="col-md-8 offset-md-2 mb-3">
          <AddProductoForm setShow={setShow} />
        </div>
      )}
    </>
  );
};

export default AddProducto;